export default function Footer() {
  return (
    <footer className="footer text-center">
      All Rights Reserved by Garkuwa Specialist Hospital
    </footer>
  );
}
